import { render, staticRenderFns } from "./CreateByRequestsForm.vue?vue&type=template&id=2288835d&scoped=true"
import script from "./CreateByRequestsForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateByRequestsForm.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CreateByRequestsForm.vue?vue&type=style&index=0&id=2288835d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2288835d",
  null
  
)

export default component.exports